(function () {
    const mainnav = document.querySelector("#mainnav");

    function viewport() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width: e[a + 'Width'], height: e[a + 'Height'] };
    }

    let lastScroll = 0;

    if (mainnav) {
        const toggle = mainnav.querySelector(".navbar-toggler")
        toggle.addEventListener("click", () => {
            window.scrollTo(0, 0);
        })

        window.addEventListener("scroll", () => {
            if (window.scrollY == 0) {
                mainnav.classList.remove("fixed");
            } else {
                //if (viewport().width > 1200) {
                    if (!mainnav.classList.contains("fixed")) {
                        mainnav.classList.add("fixed");
                    }
                //}
            }
            let currentScroll = window.scrollY;
            if (currentScroll - lastScroll > 0) {
                mainnav.classList.add("down")
                mainnav.classList.remove("up")
            } else {
                mainnav.classList.add("up")
                mainnav.classList.remove("down")
            }

            lastScroll = currentScroll;

        })
    }

    function handleNavClick(event, show) {
        const element = event.target
        const mainlink = element.closest(".mainlink")
        const navlinks = mainlink.closest(".nav-links")
        if (show == true) {
            mainnav.querySelectorAll(".mainlink").forEach(ml => {
                const nl = ml.closest(".nav-links")
                nl.classList.remove("open")
            })
            navlinks.classList.add("open")
        }
        if (show == false) {            
            mainnav.querySelectorAll(".mainlink").forEach(ml => {
                const nl = ml.closest(".nav-links")
                nl.classList.remove("open")
            })
        }
        if (show == null) {
            if (!navlinks.classList.contains("open")) {
                event.preventDefault()
                navlinks.classList.add("open")
            }
        }
    }

    if (mainnav) {
        mainnav.querySelectorAll(".nav-links").forEach(navlinks => {
            const navlink = navlinks.querySelector(".nav-link")
            if (navlinks.classList.contains("hassubpages")) {
                const navlink = navlinks.querySelector(".nav-link")
                const showbtn = navlinks.querySelector(".showsublinks")
                const hidebtn = navlinks.querySelector(".hidesublinks")
                navlink.addEventListener("click", (e) => {
                    handleNavClick(e, null);
                });
                if (showbtn) {
                    showbtn.addEventListener("click", (e) => {
                        handleNavClick(e, true);
                    });
                }
                if (hidebtn) {
                    hidebtn.addEventListener("click", (e) => {
                        handleNavClick(e, false);
                    });
                }
            }
        })

    }
})();